export default __webpack_public_path__ + "static/Concrete-Driveway-Removal-77836a89707c8b16b7f332c02bb68e0d.jpg";